<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">追求卓越，成就非凡</p>
        <p  class="font1" style="padding-top: 1vh;">进取不止，非凡自来</p>
            
        <p class="font2" style="padding-top: 2vh;">2025年8月你在富学宝典的学习成就:</p>
        <div>
            <div class="list" v-show="ReportData.coursenumMon">
                <p class="font2">学习课程<a class="font3">{{ ReportData.coursenumMon }}</a>门</p>
            </div>
            <div class="list" v-show="ReportData.creditvalueFxbd">
                <p class="font2">获得学分<a class="font3">{{ ReportData.creditvalueFxbd }}</a>个</p>
            </div>
            
            <p class="font2"  style="padding-top: 2vh;">超越了<a class="font3">{{ ReportData.rate2 ? ReportData.rate2 : 0 }}%</a>同行小伙伴！</p>
            <p class="font2" style="padding-top: 4vh;margin: 0;">每一次突破，都是成长的跃升</p>
            <p class="font2" style="margin: 0;">不停步，才能发现更强大的自己</p>
        </div>  
    </div>
</template>

<script>
export default {
      props: ["ReportData"],
      data() {
        return {
        }
      },
    }
</script>
  
<style scoped>
.body {
    background: 
        url("../../assets/25Auguest/logo.png") right  top  no-repeat,
        url("../../assets/25Auguest/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	width: 100%;
	height: 100vh;
}
.list{
    display: flex;
    justify-content: center; 
    align-items: center; 
    width: 70%;
    /* padding-left: 8%; */
    height: 7vh;
    margin: 0 auto;
    /* margin-left: 8%; */
    background-color: #88c3ea;
    margin-top: 1vh;
    border-radius: 10px;
    border: #fff solid 1px;
}
.font1 {
    width: 96%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #528ce8;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font2 { 
    width: 96%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #000;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font3 {
    font-size: 24px;
    font-weight: bold;
    color: #528ce8;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.fa{
    color:rgb(206, 144, 28);
    align-items: center;
}

@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25Auguest/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .list{
    display: flex;
    justify-content: center; 
    align-items: center; 
    width: 40%;
    height: 7vh;
    margin: 0 auto;
    background-color: #88c3ea;
    margin-top: 1vh;
    border-radius: 10px;
    border: #fff solid 1px;
}
    .font2{
        font-size: 19px;
    }
    .font3{
        font-size: 24px;
    }
}
</style>